import type { ProjectVariable } from "../../ProfessionalServices/common/types/ProjectVariable";

// A row in the resources list table.
export interface Resource {
  id: string;
  name: string;
  externalName: string;
  description: string;
  default: boolean;
}

// Controlled values for the resource create/edit form.
export interface ResourceFormValues {
  name: string;
  externalName: string;
  description: string;
  default: boolean;
  // Per-resource user-defined-field values (account-level definitions with the
  // resource's current values merged in).
  userDefinedFields: ProjectVariable[];
}

export const emptyResourceForm: ResourceFormValues = {
  name: "",
  externalName: "",
  description: "",
  default: false,
  userDefinedFields: [],
};
